module.exports = __webpack_public_path__ + "img/integration-menu.462e54e2.svg";